<template>
  <div>
    <div class="row mb-4">
      <div class="col-12" style="display: flex; align-items: center">
        <span class="display-4">
          {{ `${establishment.company_name}` }} -
          {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.INTERNAL_ORDERS") }}
        </span>
        <base-button
          v-if="
            establishment.active &&
            $currentUserCan($permissions.PERM_CREATE_ESTABLISHMENT_INTERNAL_ORDERS)
          "
          type="primary"
          icon
          size="sm"
          @click="
            () => {
              showAddInternalOrderModal = true;
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="ni ni-single-copy-04"></i>
            {{ $t("COMMON.ADD") }}
          </span>
        </base-button>
        <help-button context="internal-orders" class="ml-2" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="alert alert-secondary mb-0">
          <i class="fas fa-info-circle mr-1"></i>
          {{ $t("ESTABLISHMENT_INTERNAL_ORDERS.ESTABLISHMENT_TAB_HELP") }}
        </div>
      </div>
    </div>

    <!-- Ordering requires a SATELLITE cafeteria, being the production side requires a
         PRODUCTION one. Purely informative: nothing is blocked here, and the API
         carries no check for these rules. -->
    <div class="row mb-3" v-if="canOrder === false">
      <div class="col-12">
        <div class="alert alert-warning mb-0">
          <i class="fas fa-exclamation-triangle mr-1"></i>
          {{
            $t("ESTABLISHMENT_INTERNAL_ORDERS.ESTABLISHMENT_NOT_SATELLITE", {
              establishment: establishment.company_name,
            })
          }}
        </div>
      </div>
    </div>

    <div class="row mb-3" v-if="canProduce === false">
      <div class="col-12">
        <div class="alert alert-secondary mb-0">
          <i class="fas fa-info-circle mr-1"></i>
          {{
            $t("ESTABLISHMENT_INTERNAL_ORDERS.ESTABLISHMENT_NOT_PRODUCTION", {
              establishment: establishment.company_name,
            })
          }}
        </div>
      </div>
    </div>

    <!-- filterEstablishment matches source OR destination, so the tab shows the
         orders this establishment sends AND the ones it receives. -->
    <establishment-internal-order-list-table
      ref="internalOrderTable"
      :filterEstablishment="establishment.id"
      :hideAddButton="true"
    />

    <establishment-view-internal-orders-add-internal-order-modal
      :establishment="establishment"
      :showModal="showAddInternalOrderModal"
      @onCloseModal="showAddInternalOrderModal = false"
      @created="refreshInternalOrders"
    />
  </div>
</template>

<script>
import EstablishmentInternalOrderListTable from "@/views/Pages/InventoryModule/EstablishmentInternalOrderManagement/partials/EstablishmentInternalOrderListTable.vue";
import EstablishmentViewInternalOrdersAddInternalOrderModal from "./EstablishmentViewInternalOrdersAddInternalOrderModal.vue";
import {
  establishmentCanOrder,
  establishmentCanProduce,
} from "@/helpers/internalOrderEligibility";

export default {
  name: "EstablishmentViewInternalOrders",
  components: {
    EstablishmentInternalOrderListTable,
    EstablishmentViewInternalOrdersAddInternalOrderModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAddInternalOrderModal: false,
      // null = not resolved yet (or lookup failed): stay silent rather than warn wrongly.
      canOrder: null,
      canProduce: null,
    };
  },
  created() {
    this.checkEligibility();
  },
  watch: {
    "establishment.id": {
      handler() {
        this.checkEligibility();
      },
    },
  },
  methods: {
    async checkEligibility() {
      if (!this.establishment?.id) {
        this.canOrder = null;
        this.canProduce = null;
        return;
      }
      const [canOrder, canProduce] = await Promise.all([
        establishmentCanOrder(this.establishment.id),
        establishmentCanProduce(this.establishment.id),
      ]);
      this.canOrder = canOrder;
      this.canProduce = canProduce;
    },
    refreshInternalOrders() {
      this.$refs.internalOrderTable?.getList();
    },
  },
};
</script>
